$(function searchAndHandleCarriersSlider() {
    $.each($('.section-carriers-slider'), (_index, anchor) => {
        handleSlider(anchor);
    });
});

$(function searchAndHandleCarriersSlider() {
    $.each($('.section-grid-slider'), (_index, anchor) => {
        handleSlider(anchor, true);
    });
});

function handleSlider(anchor, isWithInterval) {
    const section = $(anchor);
    const defaultActiveElement = 0;

    section.find(`.tab-pane:eq(${defaultActiveElement})`).addClass('active');
    section.find(`.nav-tabs a[role*="tab"]:eq(${defaultActiveElement})`).addClass('active');

    const tabs = section.find('.tabs');
    const navTabs = tabs.find('.nav-tabs');

    setUpArrows(navTabs, defaultActiveElement, section, isWithInterval);
}

function setUpArrows(navTabs, defaultActiveElement, section, isWithInterval) {
    navTabs.append('<img src="/static/img/sliderArrow.svg" class="next-arrow" alt="next-arrow">');
    navTabs.prepend('<img src="/static/img/sliderArrow.svg" class="prev-arrow" alt="prev-arrow">');

    const nextArrow = section.find('.nav-tabs').find('.next-arrow');
    const prevArrow = section.find('.nav-tabs').find('.prev-arrow');

    const tab = section.find('.tabs.slider-tabs');
    const tabLength = tab.find('.tab-pane').length;

    let mainIndex = defaultActiveElement;
    let prevIndex = null;
    let interval;

    nextArrow.click(function() {
        if (mainIndex < tabLength - 1) {
            prevIndex = mainIndex;
            mainIndex++;
        } else {
            prevIndex = mainIndex;
            mainIndex = 0;
        }
        moveSlider(mainIndex, prevIndex, section);
        if (isWithInterval) {
            setInterval();
        }
    });

    prevArrow.click(function() {
        if (mainIndex > 0) {
            prevIndex = mainIndex;
            mainIndex--;
        } else {
            prevIndex = mainIndex;
            mainIndex = tabLength - 1;
        }
        if (isWithInterval) {
            setInterval();
        }
        moveSlider(mainIndex, prevIndex, section);
    });

    if (isWithInterval) {
        setInterval();
    }

    section.find('.nav-tabs a[role*="tab"]').click(function(e) {
        const index = $(this)
            .closest('li')
            .index();

        prevIndex = mainIndex;
        mainIndex = index - 1;

        if (isWithInterval) {
            setInterval();
        }
        moveSlider(mainIndex, prevIndex, section);

        e.preventDefault();
    });

    function setInterval() {
        clearInterval(interval);
        interval = window.setInterval(() => {
            prevIndex = mainIndex;
            if (mainIndex === tabLength - 1) {
                mainIndex = 0;
            } else {
                mainIndex++;
            }
            moveSlider(mainIndex, prevIndex, section);
        }, 3000);
    }
}

function moveSlider(index, prevIndex, section) {
    const tab = section.find('.tabs.slider-tabs');

    $.each(tab.find('a[role*="tab"]'), (tabIndex, anchor) => {
        $(anchor).removeClass('active');
        if (index === tabIndex) {
            $(anchor).addClass('active');
        }
    });

    if (index === prevIndex) {
        return;
    }

    const $newSlide = tab.find(`.tab-pane:eq(${index})`);
    const $prevSlide = tab.find(`.tab-pane:eq(${prevIndex})`);

    $prevSlide.animate(
        {
            opacity: 0,
        },
        200,
        () => {
            $prevSlide.removeClass('active');

            $newSlide.addClass('active').animate(
                {
                    opacity: 1,
                },
                200,
            );
        },
    );
}

function clearInterval(interval) {
    if (interval) {
        window.clearInterval(interval);
    }
}



// WEBPACK FOOTER //
// ./js/carriers-slider.js